module.exports = __webpack_public_path__ + "static/media/0022.2649defb.jpg";